export const BONOLOTO = 'bonoloto';
export const LOTTO_UK = 'lotto-uk';
export const LA_PRIMITIVA = 'la-primitiva';
export const SATURDAY_LOTTO_AU = 'saturday-lotto-au';

export const LOTTERIES_WITH_BONUS_BALL_IN_0_RANGE = [
    BONOLOTO,
    LOTTO_UK,
    LA_PRIMITIVA,
    SATURDAY_LOTTO_AU
];
